import { Vue } from 'vue-property-decorator';

import userService from '@/services/user.service';
import errorsService from '@/services/errors.service';
import accountService from '@/services/account.service';

import { ITokenModel } from '@/models/token.model';
import { IEpicGamesCallbackRequestModel, IEpicGamesCallbackResultModel, IEpicGamesUnlinkResultModel } from '../models/epic.model';

export default {
  goToEpicGames(context: Vue, useSEGARedeemer: boolean, redirectUrl?: string): void {
    context.$store.dispatch("updateIsLinkingEpicGamesLoading", true);
    context.$store.dispatch("updateIsLoading", true);

    let url: string = "";

    if (useSEGARedeemer) {
      url = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "epicgames/auth?callbackPath=/epicgames/callback";

      if (redirectUrl != null) {
        url += "&redirectUrl=" + redirectUrl;
      }
    } else {
      url = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "epicgames/auth";
    }

    accountService.get<string>(context, url)
      .then(response => {
        context.$store.dispatch("updateIsLinkingEpicGamesLoading", false);
        context.$store.dispatch("updateIsLoading", false);
        window.location.href = response;
      })
      .catch(error => {
        context.$store.dispatch("updateIsLinkingEpicGamesLoading", false);
        context.$store.dispatch("updateIsLoading", false);
        errorsService.handleErrors(context, error);
      });
  },

  callbackEpicGames(context: Vue, model: IEpicGamesCallbackRequestModel, token: ITokenModel): void {
    context.$store.dispatch("updateIsLinkingCallbackLoading", true);
    context.$store.dispatch("updateIsLinkingEpicGamesLoading", true);
    context.$store.dispatch("updateIsLoading", true);

    const url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "epicgames/callback";

    accountService.post<IEpicGamesCallbackRequestModel, IEpicGamesCallbackResultModel>(context, url, model, { headers: { Authorization: "Bearer " + token.Value } })
      .then(async response => {
        let redirectUrl = response.RedirectUrl;
        context.$store.dispatch("updateIsLinkingCallbackLoading", false);
        context.$store.dispatch("updateIsLinkingEpicGamesLoading", false);
        userService.updateUser(context, redirectUrl != null, true);
        if (redirectUrl != null) {
          redirectUrl += ((redirectUrl.includes("?") ? "&" : "?") + "epicgamesid=" + response.AccountId);
          window.location.href = redirectUrl;
          context.$store.dispatch("updateIsLoading", false);
          return;
        }
      })
      .catch(error => {
        context.$store.dispatch("updateIsLinkingCallbackLoading", false);
        context.$store.dispatch("updateIsLinkingEpicGamesLoading", false);
        context.$store.dispatch("updateIsLoading", false);
        errorsService.handleErrors(context, error);
      });
  },

  unlinkEpicGames(context: Vue, token: ITokenModel) {
    context.$store.dispatch("updateIsLinkingEpicGamesLoading", true);
    context.$store.dispatch("updateIsLoading", true);

    const url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "epicgames/unlink";

    accountService.post<object, IEpicGamesUnlinkResultModel>(context, url, {}, { headers: { Authorization: "Bearer " + token.Value } })
      .then(() => {
        context.$store.dispatch("updateIsLinkingEpicGamesLoading", false);
        context.$store.dispatch("updateIsLoading", false);

        const redirectUrl = context.$store.getters.redirectUrl;

        if (redirectUrl != null) {
          window.location.href = redirectUrl;
          return;
        }

        userService.updateUser(context, redirectUrl != null, true);
      })
      .catch(error => {
        context.$store.dispatch("updateIsLinkingEpicGamesLoading", false);
        context.$store.dispatch("updateIsLoading", false);
        errorsService.handleErrors(context, error);
      });
  }
}